module.exports = __webpack_public_path__ + "img/lions.1cbbd2d8.png";